<template>
    <v-card>
        <v-card-title>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <vue-json-to-csv
                :json-data="get_fc_data"
                :csv-title="'designtracker_fc_data'"
                :labels="export_labels">
                <v-btn color="success" small>
                    <v-icon small>mdi-file-delimited</v-icon>
                    Export to CSV
                </v-btn>
            </vue-json-to-csv>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="get_fc_data"
                :items-per-page="5"
                :search="search">
            </v-data-table>       
        </v-card-text>
    </v-card>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv'
import { mapGetters } from 'vuex';

export default {
    data: () => ({
        headers: [
            {'text': 'Room', 'align': 'center', 'sortable': true, 'value': 'parent_id'},
            {'text': 'Location', 'align': 'center', 'sortable': true, 'value': 'location'},
            {'text': 'SQM', 'align': 'center', 'sortable': true, 'value': 'sqm'},
            {'text': 'Floor Type', 'align': 'center', 'sortable': true, 'value': 'floor_type'},
            {'text': 'Price Per SQM', 'align': 'center', 'sortable': true, 'value': 'price_per_sqm'},
            {'text': 'Total', 'align': 'center', 'sortable': true, 'value': 'total'},
            {'text': 'Supplier', 'align': 'center', 'sortable': true, 'value': 'supplier_id'},
            {'text': 'Notes', 'align': 'center', 'sortable': true, 'value': 'notes'},
        ],
        project_id: null,
        users_id: null,
        search: null,
        export_labels: { 
            parent_id: {title: 'Room'},
            location: {title: 'Location'},
            sqm: {title: 'SQM'},
            floor_type: {title: 'Floor Type'},
            price_per_sqm: {title: 'Price per SQM'},
            total: {title: 'Total'},
            supplier_id: {title: 'Supplier'},
            notes: {title: 'Notes'},
        }
    }),
    components: {
        VueJsonToCsv
    },
    props: ['user_data', 'project'],
    computed: {
        ...mapGetters({
            get_fc_data:        'admin_designtracker/get_fc_data_getter'
        })
    },
    watch: {
        project() {            
            this.project_id = this.project.id
            this.users_id = this.user_data.id
        }
    }

}
</script>